import $ from 'jquery';
import anime from 'animejs';
import PubSub from 'pubsub-js';
import Page from '~/page/page';

export default class Header extends Page {
  init() {
    this.state = {
      fixed: false,
      animating: false
    };

    this.height = {
      default: this.$.root.outerHeight(),
      fixed: this.getFixedHeight()
    };
  }

  events() {
    this.$.window.on('scroll', () => this.handler());
    this.$.document.ready(() => this.handler());
  }
  handler() {
    if (this.state.animating) return;

    const offset = window.pageYOffset;
    const state = this.state.fixed;
    const bound = this.height.default * 2;

    if (offset > bound && !state) {
      this.fix();
    }

    if (offset < bound && state) {
      this.unfix();
    }
  }
  fix() {
    this.state.animating = true;

    this.$.root.addClass('is-fixed');
    this.$.root.css({
      opacity: 1,
      transform: `translateY(${this.height.fixed * -1}px)`
    });

    this.$.page.css({ paddingTop: this.height.default });

    PubSub.publish('header.fixed', {});

    anime({
      targets: this.$.root.get(0),
      duration: 400,
      translateY: 0,
      opacity: 1,
      easing: 'easeInOutQuad',
      complete: () => {
        this.state.animating = false;
        this.state.fixed = true;
      }
    });
  }
  unfix() {
    this.state.animating = true;

    anime({
      targets: this.$.root.get(0),
      duration: 200,
      opacity: 0,
      easing: 'easeInOutQuad',
      complete: () => {
        this.$.page.removeAttr('style');
        this.$.root.removeAttr('style').removeClass('is-fixed');

        this.state.fixed = false;
        this.state.animating = false;

        PubSub.publish('header.unfixed', {});
      }
    });
  }
  getFixedHeight() {
    this.$.root.addClass('is-fixed');
    const height = this.$.root.outerHeight();
    this.$.root.removeClass('is-fixed');

    return height;
  }
  getDirection() {
    const scrolled = this.$.window.scrollTop();
    const direction = scrolled < this.state.prevScroll ? 'UP' : 'DOWN';

    this.state.prevScroll = scrolled;

    return direction;
  }
  static isFixed() {
    return $('.js-header').is('.is-fixed');
  }
  static getHeight() {
    return $('.js-header').outerHeight();
  }
  static setPadding(padding) {
    $('.js-header').css({ paddingRight: padding });
  }
  static removePadding() {
    $('.js-header').css({ paddingRight: 0 });
  }
}

Page.mount(Header, '.js-header');
